import React, { useState, useEffect, forwardRef } from "react";
import { Grid } from "@material-ui/core";
import MaterialTable from "material-table";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";
import PatchedPagination from "../../layout/MTPagination";

const DisputeForm = ({ filterDataCounts, disputesItems, setSendDisputeID }) => {
  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  //set rows data
  const [rows, setRows] = useState([]);
  useEffect(() => {
    setRows([]);
    if (disputesItems) {
      disputesItems.forEach((item) => {
        setRows((rows) => [
          ...rows,
          {
            dispute_id: item.dispute_id,
            reason: item.reason,
            status: item.status,
            amount: item.amount,
            create_time: item.create_time,
            update_time: item.update_time,
            due_date: item.due_date,
          },
        ]);
      });
    }
  }, [disputesItems]);

  const rowEvents = (event, disputeID) => {
    setSendDisputeID(disputeID);
  };
  const column = [
    {
      field: "dispute_id",
      title: "Dispute ID",
      cellStyle: {
        width: 130,
        minWidth: 130,
        fontSize: 12,
      },
    },
    {
      field: "reason",
      title: "Reason",
      cellStyle: {
        width: 200,
        minWidth: 200,
        fontSize: 12,
      },
    },
    {
      field: "status",
      title: "Status",
      cellStyle: {
        width: 200,
        minWidth: 200,
        fontSize: 12,
      },
    },
    {
      field: "amount",
      title: "Amount",
      cellStyle: {
        width: 50,
        minWidth: 50,
        fontSize: 12,
      },
    },
    {
      field: "create_time",
      title: "Opened On",
      cellStyle: {
        width: 160,
        minWidth: 160,
        fontSize: 12,
      },
    },
    {
      field: "update_time",
      title: "Last Updated On",
      cellStyle: {
        width: 160,
        minWidth: 160,
        fontSize: 12,
      },
    },
    {
      field: "due_date",
      title: "Due Date",
      cellStyle: {
        width: 160,
        minWidth: 160,
        fontSize: 12,
      },
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <font size="2">
          <strong className="ml-1"> Total records: {filterDataCounts} </strong>{" "}
        </font>{" "}
        <MaterialTable
          columns={column}
          data={rows}
          icons={tableIcons}
          onRowClick={(event, rowData) => rowEvents(event, rowData.dispute_id)}
          options={{
            search: false,
            sorting: true,
            draggable: false,
            pageSizeOptions: [10, 25, 50],
            pageSize: 10,
            padding: "dense",
            showTitle: false,
            // grouping: true,
            toolbar: false,
            headerStyle: {
              fontWeight: "bold",
              fontSize: 12,
              zIndex: 0,
            },
          }}
          components={{
            Pagination: PatchedPagination,
          }}
        />{" "}
      </Grid>{" "}
    </Grid>
  );
};

export default DisputeForm;
